module.exports = __webpack_public_path__ + "static/media/buzon.96696c9b.svg";